// extracted by mini-css-extract-plugin
export default {"tabs-wrapper":"style_tabs-wrapper__3edO6","tab-btn":"style_tab-btn__i6FC5","tab-active-btn":"style_tab-active-btn__xQSJ6"};